import { call, put, select } from 'redux-saga/effects';
import {
  setLoading,
  setError,
  setFocusItemsList,
  setNewFocusItem,
  setSuccess,
  setProcessing, updateBundleIdentifierFlagInList, setSearchLoading, setSearchData
} from '../../slices/focusItemsSlice';
import {
  requestFocusItemList,
  requestFocusItemCreation,
  requestUpdateFocusItem,
  requestDeleteFocusItem, getBundleTimers, patchUpdateBundleTimers,
  requestFocusItem
} from '../requests/focusItemService';
import { toast } from 'react-toastify';
import { reset, setLoading as setDynamicLoading, setResult } from "../../slices/dynamicElementsSlice";

function* handleFetchFocusItems() {
  const { page: currentPage, tab } = yield select((state) => state.focusItem);
  try {
    yield put(setLoading());
    const { data: { data, page, total_pages } } = yield call(() => requestFocusItemList((currentPage), tab));
    yield put(setFocusItemsList({ totalPages: total_pages, page, data }));
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;

    yield put(setError(errMsg));
  }
}

function* handleCreateFocusItem(action) {
  const { focusItemPayload } = action.payload;
  try {
    yield put(setProcessing());
    const { data } = yield call(() =>
      requestFocusItemCreation({
        ...focusItemPayload,
        extras: {
          ...focusItemPayload.extras,
          total_items: focusItemPayload.items.length,
          display_type: focusItemPayload.display_type
        }
      })
    );
    yield put(setNewFocusItem(data));
    toast.success('Item added successfully!');
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg);
  } finally {
    yield put(setProcessing(false));
  }
}

function* handleUpdateFocusItem(action) {
  const { focusItemPayload } = action.payload;
  try {
    yield put(setProcessing());
    const { data } = yield call(() =>
      requestUpdateFocusItem({
        ...focusItemPayload,
        extras: {
          ...focusItemPayload.extras,
          total_items: focusItemPayload.items.length,
          display_type: focusItemPayload.display_type
        }
      })
    );
    yield put(setSuccess({ actionType: 'update', payload: data }));
    toast.info('Item updated successfully!');
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg);
    yield put(setError(errMsg));
  } finally {
    yield put(setProcessing(false));
    yield put(setError(""));
  }
}

function* handleDeleteFocusItem(action) {
  const { focusItemId } = action.payload;
  try {
    yield put(setProcessing());
    yield call(() => requestDeleteFocusItem(focusItemId));
    yield put(setSuccess({ actionType: 'delete', payload: focusItemId }));
    toast.success('Item deleted successfully!');
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg);
  } finally {
    yield put(setProcessing(false));
  }
}

function* handleGetBundleTimers() {
  const element = 'bundleTimers';
  try {
    yield put(setDynamicLoading({ element, loading: true }));
    const { data } = yield call(() => getBundleTimers());

    yield put(setResult({ element, loading: false, data }));

  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setResult({ element, loading: false, error: errMsg }));
  }
}

function* handleUpdateTimerItem(action) {
  const element = 'editing';
  const bundleElement = 'bundleTimers';
  const { id, add = true } = action.payload;
  try {
    yield put(setDynamicLoading({ element, loading: true }));
    const { data } = yield call(() => patchUpdateBundleTimers(id, add));
    toast.success(add ? 'Item added successfully!' : 'Item removed successfully!');
    yield put(reset({ element }));
    yield put(updateBundleIdentifierFlagInList({ remove: !add, id }));
    if (add) {
      yield put(setResult({ element: bundleElement, loading: false, data: [data] }));
    } else {
      yield put(setResult({ element: bundleElement, loading: false, data: [] }));
    }
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setResult({ element, loading: false }));
    toast.error(errMsg);
  }
}

function* handleFetchFocusItem(action) {
  try {
    yield put(setSearchLoading(true));
    const { data } = yield call(() =>requestFocusItem(action.payload));
    yield put(setSearchData({ data }));
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;

    yield put(setSearchData({error:errMsg}));
  }
}

export {
  handleFetchFocusItems,
  handleCreateFocusItem,
  handleUpdateFocusItem,
  handleDeleteFocusItem,
  handleGetBundleTimers,
  handleUpdateTimerItem,
  handleFetchFocusItem
};
